// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import Image from 'next/image';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import { getAssetHostURL } from '@tcp/core/src/utils/';
import errorBoundary from '@tcp/core/src/components/common/hoc/withErrorBoundary/errorBoundary';
import { getParsedProductBadges } from '@tcp/core/src/components/features/browse/ProductListing/molecules/ProductList/utils/productsCommonUtils';
import ESGBadgeContainer from '../styles/ESGBadge.style';

const ESGBadge = (props) => {
  const { productBadges } = props;

  const parsedProductBadges = getParsedProductBadges(productBadges);

  return parsedProductBadges && parsedProductBadges.length > 0 ? (
    <ESGBadgeContainer>
      {parsedProductBadges.map((badge) => {
        const { id, title, longDescription } = badge;
        const imageURL = `${getAssetHostURL()}/v1/ecom/assets/esg/${id}.svg`;

        return (
          <div className="esg-badge-wrapper" key={id}>
            <div className="esg-badge-icon-wrapper">
              <div className="esg-badge-icon">
                <Image src={imageURL} width={34} height={34} alt={title} layout="fill" />
              </div>
            </div>
            <div className="esg-badge-text-wrapper">
              <BodyCopy
                className="esg-badge-title"
                fontSize="fs12"
                fontFamily="secondary"
                component="div"
              >
                {title}
              </BodyCopy>
              <BodyCopy
                className="esg-badge-description"
                component="p"
                dangerouslySetInnerHTML={{ __html: longDescription }}
                fontSize="fs12"
                fontFamily="secondary"
              />
            </div>
          </div>
        );
      })}
    </ESGBadgeContainer>
  ) : null;
};

ESGBadge.propTypes = {
  productBadges: PropTypes.string.isRequired,
};

export { ESGBadge as ESGBadgeVanilla };
export default React.memo(errorBoundary(ESGBadge));
